(function () {
  if (window.AAProductGridItemInitialized) return;
  window.AAProductGridItemInitialized = true;

  function closeAllPopovers(scope) {
    const root = scope || document;

    root.querySelectorAll('.aa-product-card__cartWrap.is-open, .aa-icons__cartWrap.is-open').forEach(function (wrap) {
      wrap.classList.remove('is-open');

      const toggle = wrap.querySelector('[data-aa-cart-toggle]');
      const popover = wrap.querySelector('.aa-product-card__cartPopover, .aa-icons__cartPopover');

      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (popover) popover.setAttribute('aria-hidden', 'true');
    });
  }

  async function addCardProduct(form, triggerButton) {
    if (!form || form.dataset.aaAdding === 'true') return;

    form.dataset.aaAdding = 'true';

    if (triggerButton) {
      triggerButton.disabled = true;
      triggerButton.classList.add('is-loading');
    }

    try {
      const formData = new FormData(form);
      formData.append('sections', 'cart-ajax');

      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });

      const result = await response.json();

      if (!response.ok) {
        const message =
          result && result.description
            ? result.description
            : 'Unable to add this product to the cart.';

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:error', {
            detail: { errorMessage: message }
          })
        );

        throw new Error(message);
      }

      // Let the theme rebuild + open the drawer itself
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: result,
            addToCartBtn: triggerButton || null
          }
        })
      );
    } catch (error) {
      console.error('AA product card add to cart failed', error);
    } finally {
      form.dataset.aaAdding = 'false';

      if (triggerButton) {
        triggerButton.disabled = false;
        triggerButton.classList.remove('is-loading');
      }
    }
  }

  function initProductCard(root) {
    if (!root || root.dataset.aaInit === 'true') return;
    root.dataset.aaInit = 'true';

    const form = root.querySelector('[data-aa-card-form]');
    const addBtn = root.querySelector('[data-aa-add-to-cart]');
    const toggle = root.querySelector('[data-aa-cart-toggle]');
    const popover = root.querySelector('.aa-product-card__cartPopover, .aa-icons__cartPopover');
    const sellingPlanInput = form ? form.querySelector('input[name="selling_plan"]') : null;
    const optionButtons = root.querySelectorAll('[data-aa-purchase-option]');

    if (!form) return;

    function openPopover() {
      closeAllPopovers(document);
      root.classList.add('is-open');

      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (popover) popover.setAttribute('aria-hidden', 'false');
    }

    function closePopover() {
      root.classList.remove('is-open');

      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      if (popover) popover.setAttribute('aria-hidden', 'true');
    }

    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addCardProduct(form, addBtn);
      });
    }

    if (toggle && popover && sellingPlanInput && optionButtons.length) {
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (root.classList.contains('is-open')) {
          closePopover();
        } else {
          openPopover();
        }
      });

      root.addEventListener('mouseenter', openPopover);
      root.addEventListener('focusin', openPopover);

      root.addEventListener('mouseleave', function () {
        if (!root.matches(':focus-within')) {
          closePopover();
        }
      });

      root.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (!root.contains(document.activeElement)) {
            closePopover();
          }
        });
      });

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();

          optionButtons.forEach(function (button) {
            button.classList.remove('is-selected');
          });

          btn.classList.add('is-selected');

          if (btn.getAttribute('data-aa-purchase-option') === 'sub') {
            sellingPlanInput.value = btn.getAttribute('data-selling-plan-id') || '';
          } else {
            sellingPlanInput.value = '';
          }

          closePopover();
          addCardProduct(form, toggle);
        });
      });
    }
  }

  function initAllProductCards(scope) {
    const root = scope || document;
    root.querySelectorAll('[data-aa-product-card]').forEach(initProductCard);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-aa-product-card]')) {
      closeAllPopovers(document);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeAllPopovers(document);
    }
  });

  document.addEventListener('page:loaded', function () {
    initAllProductCards(document);
  });

  document.addEventListener('quickview:loaded', function () {
    initAllProductCards(document);
  });

  document.addEventListener('quickadd:loaded', function () {
    initAllProductCards(document);
  });

  document.addEventListener('shopify:section:load', function (e) {
    initAllProductCards(e.target);
  });

  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    initAllProductCards(document);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAllProductCards(document);
    });
  }

  window.AAInitProductGridItems = initAllProductCards;
})();